import { mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters('auth', ['profile']),
		...mapGetters('settings', ['appCore']),

		userIsMember() {
			return this.profile.is_member
		},
		userChapters() {
			return this.profile.chapters
		},
		isBlocked() {
			return this.blockedStatus(
				this.pageBlockedName,
				this.pageBlockedName === 'threads' ? +this.$route.query.thread_menu_id : null,
				this.pageBlockedName === 'resources' ? (this.$route.query.advance ? 1 : 0) : null,
                this.pageBlockedName === 'rss-feed' ? +this.$route.query.feed_id : null,
			)
		},
		blockRole() {
			return this.blockedRole(
				this.pageBlockedName,
				this.pageBlockedName === 'threads' ? +this.$route.query.thread_menu_id : null,
				this.pageBlockedName === 'resources' ? (this.$route.query.advance ? 1 : 0) : null,
                this.pageBlockedName === 'rss-feed' ? +this.$route.query.feed_id : null,
			)
		},
	},
    methods: {
        blockedStatus(routeName, thread_menu_id, advanced_resources, feed_id) {
            if (this.appCore === null) return null

            const pattern = /\/\/(.+)/
            let route
            if (feed_id !== null && feed_id !== undefined) {
                route = this.appCore.app_menu.find((item) => {
                    const m = item.url && item.url.match(pattern)
                    if (!m) return false
                    return m[1] === this.pageBlockedName &&
                        item.params &&
                        +item.params.feed_id === +feed_id
                })
            }
            else if (advanced_resources !== null && advanced_resources !== undefined) {
                route = this.appCore.app_menu.find((item) => {
                    const m = item.url && item.url.match(pattern)
                    if (!m) return false
                    const enabled = !!(item.params && item.params.enable_advanced)
                    return m[1] === this.pageBlockedName &&
                        (advanced_resources ? enabled : !enabled)
                })
            }
            else if (thread_menu_id) {
                route = this.appCore.app_menu.find((item) => {
                    const m = item.url && item.url.match(pattern)
                    if (!m) return false
                    return m[1] === this.pageBlockedName &&
                        item.params &&
                        +item.params.thread_menu_id === +thread_menu_id
                })
            }
            else {
                route = this.appCore.app_menu.find((item) => {
                    const m = item.url && item.url.match(pattern)
                    return m && m[1] === this.pageBlockedName
                })
            }

            if (route) {
                if (route.chapters && route.chapters.length) {
                    const hasChapter = route.chapters.some((chapter) =>
                        this.userChapters.some((u) => u.chapter_id === chapter)
                    )
                    if (!hasChapter) return true
                }
                if ((!route.chapters || route.chapters.length === 0) && route.exclude_chapters && route.exclude_chapters.length) {
                    const hasExcludedChapter = route.exclude_chapters.some((chapter) =>
                        this.userChapters.some((u) => u.chapter_id === chapter)
                    )
                    if (hasExcludedChapter) return true
                }

                if (route.role !== null && route.role !== undefined) {
                    return !!(this.userIsMember && !route.role) || !!(!this.userIsMember && route.role)
                }
            }
            return false
        },

        blockedRole(routeName, thread_menu_id = null, advanced_resources = null, feed_id = null) {
            if (this.appCore === null) return ''

            const pattern = /\/\/(.+)/
            let route
            if (feed_id !== null && feed_id !== undefined) {
                route = this.appCore.app_menu.find((item) => {
                    const m = item.url && item.url.match(pattern)
                    if (!m) return false
                    return m[1] === routeName &&
                        item.params &&
                        +item.params.feed_id === +feed_id
                })
            }
            else if (advanced_resources !== null && advanced_resources !== undefined) {
                route = this.appCore.app_menu.find((item) => {
                    const m = item.url && item.url.match(pattern)
                    if (!m) return false
                    const enabled = !!(item.params && item.params.enable_advanced)
                    return m[1] === routeName && (advanced_resources ? enabled : !enabled)
                })
            }
            else if (thread_menu_id) {
                route = this.appCore.app_menu.find((item) => {
                    const m = item.url && item.url.match(pattern)
                    if (!m) return false
                    return m[1] === routeName &&
                        item.params &&
                        +item.params.thread_menu_id === +thread_menu_id
                })
            }
            else {
                route = this.appCore.app_menu.find((item) => {
                    const m = item.url && item.url.match(pattern)
                    return m && m[1] === routeName
                })
            }

            if (!route) return ''
            if (route.chapters && route.chapters.length) {
                const hasChapter = route.chapters.some((chapter) =>
                    this.userChapters.some((u) => u.chapter_id === chapter)
                )
                if (!hasChapter) return 'subgroup-'
            }
            if ((!route.chapters || route.chapters.length === 0) && route.exclude_chapters && route.exclude_chapters.length) {
                const hasExcludedChapter = route.exclude_chapters.some((chapter) =>
                    this.userChapters.some((u) => u.chapter_id === chapter)
                )
                if (hasExcludedChapter) return 'excluded-subgroup-'
            }

            return route.role ? '' : 'non-'
        },
    }
}
